import StarRating from "@/components/StarRating.vue";
import "@/utils/Prototypes/prototypeFunctions";
import "bootstrap";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "./di/queryClient";
import { createPinia } from "pinia";
import { migrateLegacyState } from "./store/migrateLegacyState";
import { discardForeignSession, migrateUnprefixedState, persistedState } from "./store/persistence";
import money from "v-money3";
import { createApp } from "vue";
import App from "./App.vue";
import "./assets/js/jquery.js";
import BottomActionsContainer from "./components/BottomActionsContainer.vue";
import CalendarComponent from "./components/CalendarComponent/CalendarComponent.vue";
import ConfirmationAlert from "./components/ConfirmationAlert/ConfirmationAlert.vue";
import Container from "./components/Container.vue";
import CopyText from "./components/CopyText.vue";
import DocumentInput from "./components/DocumentInput.vue";
import EmptyState from "./components/EmptyState.vue";
import FormButton from "./components/FormComponents/FormButton.vue";
import { dragScroll } from "./directives/dragScroll";
import CheckboxInput from "./components/FormComponents/CheckboxInput.vue";
import SwitchInput from "./components/FormComponents/SwitchInput.vue";
import MoneyInput from "./components/FormComponents/MoneyInput.vue";
import PasswordInput from "./components/FormComponents/PasswordInput.vue";
import RadioInput from "./components/FormComponents/RadioInput.vue";
import SelectInput from "./components/FormComponents/SelectInput.vue";
import TextAreaInput from "./components/FormComponents/TextAreaInput.vue";
import TextInput from "./components/FormComponents/TextInput.vue";
import LoadingContainer from "./components/LoadingContainer.vue";
import ModalComponent from "./components/ModalComponent.vue";
import Navbar from "./components/Navbar.vue";
import OffcanvasComponent from "./components/OffcanvasComponent.vue";
import PamiaWidget from "./components/PamiaWidget.vue";
import PhIcons from "./components/PhIcons.vue";
import SearchBar from "./components/SearchBar.vue";
import Sidebar from "./components/Sidebar.vue";
import TimezoneAlert from "./components/TimezoneAlert.vue";
import VersionComponent from "./components/VersionComponent.vue";
import router from "./router";
import FeedbackDetail from "./views/FeedbackDetail/FeedbackDetail.vue";

// @ts-ignore
import "./assets/theme/scss/theme.scss";
// @ts-ignore
import "@fortawesome/fontawesome-free/css/all.css";
//@ts-ignore
import "moment/locale/pt-br";

migrateUnprefixedState();
const pinia = createPinia();
pinia.use(persistedState());
const app = createApp(App);


app.component("Navbar", Navbar);
app.component("Sidebar", Sidebar);
app.component("LoadingContainer", LoadingContainer);
app.component("EmptyState", EmptyState);
app.component("Container", Container);
app.component("MoneyInput", MoneyInput);
app.component("SearchBar", SearchBar);
app.component("TextInput", TextInput);
app.component("RadioInput", RadioInput);
app.component("SelectInput", SelectInput);
app.component("TextAreaInput", TextAreaInput);
app.component("PasswordInput", PasswordInput);
app.component("FormButton", FormButton);
app.component("CheckboxInput", CheckboxInput);
app.component("SwitchInput", SwitchInput);
app.component("ModalComponent", ModalComponent);
app.directive("drag-scroll", dragScroll);
app.component("ConfirmationAlert", ConfirmationAlert);
app.component("PhIcons", PhIcons);
app.component("BottomActionsContainer", BottomActionsContainer);
app.component("CopyText", CopyText);
app.component("CalendarComponent", CalendarComponent);
app.component("FeedbackDetail", FeedbackDetail);
app.component("StarRating", StarRating);
app.component("DocumentInput", DocumentInput);
app.component("OffcanvasComponent", OffcanvasComponent);
app.component("VersionComponent", VersionComponent);
app.component("TimezoneAlert", TimezoneAlert);
app.component("PamiaWidget", PamiaWidget);

app.use(VueQueryPlugin, { queryClient }).use(pinia);
migrateLegacyState(pinia);
discardForeignSession(pinia);
app.use(router).use(money).mount("#app");
